import Barcode from './Barcode';
import CountPerPack from './CountPerPack';
import PackType from './PackType';
import PricePerPack from './PricePerPack';
import ProductName from './ProductName';
import Stock from './Stock';
import SupplierName from './SupplierName';
import UnitPrice from './UnitPrice';
import StockValue from './StockValue';

export const labels = {
  StockValue: 'Készletérték',
  CountPerPack: 'Darab / kiszerelés',
  PackType: 'Kiszerelés',
  PricePerPack: 'Egységár',
  ProductName: 'Terméknév',
  Stock: 'Készlet',
  SupplierName: 'Beszállító',
  UnitPrice: 'Db egységár',
  Barcode: 'Azonosító',
};

export const allColumns = [{
  value: 'Barcode',
}, {
  value: 'CountPerPack',
}, {
  value: 'PackType',
}, {
  value: 'PricePerPack',
}, {
  value: 'ProductName',
}, {
  value: 'Stock',
}, {
  value: 'SupplierName',
}, {
  value: 'UnitPrice',
}, {
  value: 'StockValue',
}];

export const defaultColumns = [
  {
    value: 'Barcode',
    fixed: true,
  },
  {
    value: 'ProductName',
    fixed: true,
  },
  {
    value: 'PackType',
  },
  {
    value: 'CountPerPack',
  },
  {
    value: 'SupplierName',
  },
  {
    value: 'Stock',
  },
  {
    value: 'PricePerPack',
  },
  {
    value: 'UnitPrice',
  },
  {
    value: 'StockValue',
  },
];

export const defaultSort = {
  prop: Barcode.propName,
  order: 'descending'
};

export default {
  Barcode,
  StockValue,
  CountPerPack,
  PackType,
  PricePerPack,
  ProductName,
  Stock,
  SupplierName,
  UnitPrice,
};
